import axiosInstance from "./axiosInstance";



export const logoutMerchantUser = async () => {

  

  try {
    const response= await axiosInstance.post("/api/auth/marchant/logout");
   return {
      success: true,
      data: response?.data?.data,
      message: response?.data?.message || "successful",
    };
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        error.response?.data?.error ||
        "Faild To Create.",
      status: error.response?.status || 500,
    };
  }
};

export const Login_User = async (payload) => {
  try {
    const response = await axiosInstance.post("/api/auth/login", payload);

    return {
      success: true,
      data: response?.data?.data,
      message: response?.data?.message || "Login successful",
    };
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        error.response?.data?.error ||
        "Login failed. Please try again.",
      status: error.response?.status || 500,
    };
  }
};


export const admin_UserList = async (params={}) => {
  try {
    const response = await axiosInstance.get("/api/admin/all/user/list",{
      params:params
    });

    return {
      success: true,
      data: response?.data?.data,
      message: response?.data?.message || "successful",
    };
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        error.response?.data?.error ||
        "Server Error",
      status: error.response?.status || 500,
    };
  }
};


export const admin_SingleUser = async (id) => {
  try {
    const response = await axiosInstance.get(`/api/admin/single/user-data/${id}`,);

    return {
      success: true,
      data: response?.data?.data,
      message: response?.data?.message || "successful",
    };
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        error.response?.data?.error ||
        "Server Error",
      status: error.response?.status || 500,
    };
  }
};

export const admin_UserPerformance = async (id, range = "30d", dates = {}) => {
  try {
    const response = await axiosInstance.get(
      `/api/admin/single/user-performance/${id}`,
      {
        params: {
          range,
          ...(range === "custom"
            ? { startDate: dates.startDate, endDate: dates.endDate }
            : {}),
        },
      }
    );
    return {
      success: true,
      data: response?.data?.data,
      message: response?.data?.message || "successful",
    };
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        error.response?.data?.error ||
        "Server Error",
      status: error.response?.status || 500,
    };
  }
};

export const admin_UserRelations = async (id) => {
  try {
    const response = await axiosInstance.get(
      `/api/admin/single/user-relations/${id}`
    );
    return {
      success: true,
      data: response?.data?.data,
      message: response?.data?.message || "successful",
    };
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        error.response?.data?.error ||
        "Server Error",
      status: error.response?.status || 500,
    };
  }
};



export const singleMerchantKycProfile = async (userId) => {
  try {
    const response = await axiosInstance.get(
      `/api/admin/single/user-kycprofile/${userId}`
    );

    return {
      success: true,
      data: response?.data?.data,
      message: response?.data?.message || "Success",
    };
  } catch (error) {
    return {
      success: false,
      message:
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        "Server error",
      status: error?.response?.status || 500,
    };
  }
};


export const getSingleMerchantStore_Admin = async (username) => {
  try {
    const response= await axiosInstance.get(`/api/auth/merchant/business/${username}`);
   return {
      success: true,
      data: response?.data?.data,
      message: response?.data?.message || "successful",
    };
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        error.response?.data?.error ||
        "Faild To Create.",
      status: error.response?.status || 500,
    };
  }
};



export const claimRefundApi = async (payload) => {
  try {
    const res = await axiosInstance.post(
      "/api/admin/transaction/refund/claim",
      payload
    );
    return res.data;
  } catch (error) {
    throw error?.response?.data || {
      success: false,
      message: "Refund request failed"
    };
  }
};



export const updateUserCommission  = async (id,data) => {
  try {
    const response = await axiosInstance.put(`/api/admin/single/update/user-rate/${id}`,data);

    return {
      success: true,
      data: response?.data?.data,
      message: response?.data?.message || "successful",
    };
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        error.response?.data?.error ||
        "Server Error",
      status: error.response?.status || 500,
    };
  }
};



export const admin_UpdateUserPlan = async (id, planId) => {
  try {
    const response = await axiosInstance.patch(
      `/api/admin/single/update/user-plan/${id}`,
      { planId }
    );

    return {
      success: true,
      data: response?.data?.data,
      message: response?.data?.message || "Plan updated successfully",
    };
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        error.response?.data?.error ||
        "Server Error",
      status: error.response?.status || 500,
    };
  }
};



export const toggleUserFreezeAPI = async (data) => {
  try {
    const response = await axiosInstance.post("/api/admin/unfreeze_freeze/user",data);

    return {
      success: true,
      data: response?.data?.data,
      message: response?.data?.message || "successful",
    };
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        error.response?.data?.error ||
        "Server Error",
      status: error.response?.status || 500,
    };
  }
};



export const admin_ToggleUserActive = async (id) => {
  try {
    const response = await axiosInstance.patch(
      `/api/admin/user/${id}/toggle-active`
    );
    return {
      success: true,
      data: response?.data?.data,
      message: response?.data?.message || "Status updated",
    };
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        error.response?.data?.error ||
        "Status update failed",
      status: error.response?.status || 500,
    };
  }
};

export const admin_SoftDeleteUser = async (id) => {
  try {
    const response = await axiosInstance.delete(`/api/admin/user/${id}`);
    return {
      success: true,
      data: response?.data?.data,
      message: response?.data?.message || "User deleted",
    };
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        error.response?.data?.error ||
        "Delete failed",
      status: error.response?.status || 500,
    };
  }
};

export const admin_UserStatusUpdate = async (id,data) => {
  try {
    const response = await axiosInstance.patch(`/api/admin/merchant/updateStatus/${id}`,data);

    return {
      success: true,
      data: response?.data?.data,
      message: response?.data?.message || "successful",
    };
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        error.response?.data?.error ||
        "Server Error",
      status: error.response?.status || 500,
    };
  }
};


export const updateMarchantPassword = async (id,payload) => {
  try {
    const response= await axiosInstance.put(`/api/auth/update-password/marchant/${id}`, payload);
   return {
      success: true,
      data: response?.data?.data,
      message: response?.data?.message || "successful",
    };
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        error.response?.data?.error ||
        "Faild To Create.",
      status: error.response?.status || 500,
    };
  }
};
export const updateMarchantIamges = async (id, payload) => {
  try {
    const response = await axiosInstance.put(`/api/auth/update-user/merchant/${id}`, payload);

    return {
      success: true,
      data: response?.data?.user, // ⚠ directly take user
      message: response?.data?.message || "successful",
    };
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        error.response?.data?.error ||
        "Failed To Update.",
      status: error.response?.status || 500,
    };
  }
};

export const step2varification = async (data) => {
  try {
   const response = await axiosInstance.post("/api/paysprint/admin/aeps/2fa-registration",data);

    return {
      success: true,
      data: response?.data?.data,
      message: response?.data?.message || "successful",
    };
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        error.response?.data?.error ||
        "Server Error",
      status: error.response?.status || 500,
    };
  }
};

export const VerifyUserMPin = async (payload) => {
  try {
    const response = await axiosInstance.post("/api/auth/verify/mpin", payload);
    return {
      success: true,
      data: response.data?.data,
      status: response.status,
    };
  } catch (error) {
   return {
      success: false,
      code: error.response?.data?.code,
      message:
        error.response?.data?.message ||
        error.response?.data?.error ||
        "Mpin  failed. Please try again.",
      data: error.response?.data?.data,
      status: error.response?.status || 500,
    };
  }

};

export const forgetPassword = async (payload) => {
  try {
    const response = await axiosInstance.post("/api/user/forget-pass", payload);

    return {
      success: true,
      data: response?.data?.data,
      message: response?.data?.message || "Otp Send successful",
    };
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        error.response?.data?.error ||
        "Login failed. Please try again.",
      status: error.response?.status || 500,
    };
  }
};

export const verifyPassword = async (payload) => {
  try {
    const response = await axiosInstance.post("/api/user/verify-otp", payload);

    return {
      success: true,
      data: response?.data?.data,
      message: response?.data?.message || "Otp Send successful",
    };
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        error.response?.data?.error ||
        "Login failed. Please try again.",
      status: error.response?.status || 500,
    };
  }
};


export const resetPassword = async (payload) => {
  try {
    const response = await axiosInstance.post("/api/user/reset-pass", payload);

    return {
      success: true,
      data: response?.data?.data,
      message: response?.data?.message || "Otp Send successful",
    };
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        error.response?.data?.error ||
        "Login failed. Please try again.",
      status: error.response?.status || 500,
    };
  }
};

export const startMerchantKyc = async (merchantId) => {
  try {
   const response = await axiosInstance.post("/api/paysprint/onboard/url", {
    merchantId,
  });

    return {
      success: true,
      data: response?.data,
      message: response?.data?.message || "successful",
    };
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        error.response?.data?.error ||
        "Server Error",
      status: error.response?.status || 500,
    };
  }
};

export const enquiryWebsiteForm = async (params={}) => {
  try {
   const response = await axiosInstance.get("/api/enquiry",{
    params:params
   });

    return {
      success: true,
      data: response?.data?.data,
      message: response?.data?.message || "successful",
    };
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        error.response?.data?.error ||
        "Server Error",
      status: error.response?.status || 500,
    };
  }
};


export const fetchTeamMembers = async (params={}) => {
  try {
    const response = await axiosInstance.get(`/api/user/team_member`,{
        params:params
    });
    return {
      success:response.data.success || true,
      data: response?.data?.data,
      message: response?.data?.message || "successful",
    };
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        error.response?.data?.error ||
        " failed. Please try again.",
      status: error.response?.status || 500,
    };
  }
};


export const deleteWebsiteEnquiry = async (id) => {
  try {
   const response = await axiosInstance.delete(`/api/admin/enquiry/delete/${id}`);

    return {
      success: true,
      data: response?.data?.data,
      message: response?.data?.message || "successful",
    };
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        error.response?.data?.error ||
        "Server Error",
      status: error.response?.status || 500,
    };
  }
};

export const editMyKycDetails = async (payload) => {
  try {
    const response = await axiosInstance.put(
      "/api/auth/kyc/me",
      payload
    );

    return {
      success: response?.data?.success ?? true,
      data: response?.data?.data,
      message:
        response?.data?.message ||
        "KYC updated successfully",
    };
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        error.response?.data?.error ||
        "Failed to update KYC.",
      status: error.response?.status || 500,
    };
  }
};